<template>
  <div>
    <div>
      <div class="row ml-n0">
        <div class="col-md-2 border-right">
          <custom-radio
            v-model="model.recurrenceType"
            name="rbRecurrence"
            :options="recurrenceOptions"
            @input="onChangeRecurrenceType"
          />
        </div>
        <div class="col-md-10">
          <div
            v-if="model.recurrenceType == recurType.DAILY"
            class="color-gray-6 font-14 font-weight-normal mt-4"
          >
            Días Laborales
          </div>
          <div v-if="model.recurrenceType == recurType.WEEKLY" class="row ml-2">
            <div class="col-md-3">
              <div class="color-secondary-6 font-14 font-weight-normal">
                Repetir cada:
              </div>
              <validation-provider v-slot="{ errors }" rules="required">
                <b-form-select
                  v-model="model.repeatEach"
                  class="w-25 mt-2"
                  :options="weekOptions"
                />
                <span class="color-secondary-6 font-14 font-weight-normal ml-2">
                  /Semana
                </span>
                <error
                  v-if="errors[0]"
                  message="Campo requerido."
                  variant="no-border"
                />
              </validation-provider>
            </div>
            <div>
              <div class="d-flex border rounded mt-3 ml-n5 pr-3">
                <div
                  v-for="(item, index) in model.weekDays"
                  :key="`week-day-${index}`"
                  class="ml-3 my-2 flex-grow-1"
                >
                  <check-box
                    v-model="item.value"
                    class="checkbox flex-grow-1"
                    :text="item.name"
                  />
                </div>
              </div>
              <error
                v-if="validations.invalidWeekDay"
                :message="validations.invalidWeekDay"
                variant="no-border ml-n5"
              />
            </div>
          </div>
          <div v-if="model.recurrenceType == recurType.MONTHLY">
            <div class="row">
              <div class="col-md-12 d-flex align-items-center mt-4">
                <div class="d-flex align-items-center">
                  <span
                    class="color-secondary-6 font-16 font-weight-normal ml-1"
                  >
                    Día
                  </span>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-drop-down
                      v-model="model.monthDay"
                      class="mx-3 w-100"
                      custom-error-msg="Campo requerido."
                      :disabled="model.monthRecurrType"
                      :error="errors[0]"
                      fieldkey="id"
                      fieldname="name"
                      :options="monthDaysOptions"
                    />
                  </validation-provider>
                </div>
                <div class="d-flex align-items-center ml-4">
                  <span
                    class="color-secondary-6 font-16 font-weight-normal ml-1"
                  >
                    de cada
                  </span>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-drop-down
                      v-model="model.repeatEach"
                      class="mx-3 w-100"
                      custom-error-msg="Campo requerido."
                      :disabled="model.monthRecurrType"
                      :error="errors[0]"
                      fieldkey="id"
                      fieldname="name"
                      :options="monthsOptions"
                    />
                  </validation-provider>
                  <span
                    class="color-secondary-6 font-16 font-weight-normal ml-4"
                  >
                    Mes(es)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-secondary-3 rounded p-3 mt-5 pb-4">
      <div class="row">
        <div class="col-md-12 d-flex align-items-center">
          <div class="d-flex flex-row align-items-center">
            <em
              class="fas fa-business-time rounded-circle shadow p-2 color-primary-2 mr-2 font-12"
            />
            <span class="color-black font-16 font-weight-bold ml-1">
              Rango de Recurrencia
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-3 ml-1">
        <div class="col-md-4 d-flex align-items-center">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-radio
              v-model="model.rangeType"
              class="mt-4"
              :error="errors[0]"
              name="rbRecurrenceType"
              :options="[{ label: '', value: 1 }]"
              @input="onChangeRangeRecurrType"
            />
          </validation-provider>
          <validation-provider
            v-slot="{ errors }"
            :disabled="model.rangeType != recurRangeType.DATE_FINALIZE"
            rules="required"
          >
            <custom-date-picker
              v-model="model.rangeFinalizeDate"
              class="w-100"
              custom-error-msg="Campo requerido."
              :disabled="model.rangeType != recurRangeType.DATE_FINALIZE"
              :error="
                errors[0] && model.rangeType == recurRangeType.DATE_FINALIZE
              "
              label="Fecha de Finalización:"
              :min-date="minStartDate"
              placeholder="DD/MM/YYYY"
            />
          </validation-provider>
        </div>
        <div class="col-md-8">
          <div class="color-secondary-6 font-14 font-weight-normal ml-5">
            Fecha luego de:
          </div>
          <div class="d-flex align-items-center mt-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-radio
                v-model="model.rangeType"
                :error="errors[0]"
                name="rbRecurrenceType"
                :options="[{ label: '', value: 2 }]"
                @input="onChangeRangeRecurrType"
              />
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              :disabled="model.rangeType != recurRangeType.DATE_AFTER_OF"
              rules="required"
            >
              <b-form-select
                v-model="model.rangeAfterOf"
                class="date-after"
                :disabled="model.rangeType != recurRangeType.DATE_AFTER_OF"
                :options="rangeAfterOfOptions"
              />
              <error
                v-if="
                  errors[0] && model.rangeType == recurRangeType.DATE_AFTER_OF
                "
                message="Campo requerido."
                variant="no-border"
              />
            </validation-provider>
            <span class="color-secondary-6 font-14 font-weight-normal ml-3">
              Recurrencias
            </span>
          </div>
        </div>
      </div>
      <error
        v-if="validations.invalidDate"
        :message="validations.invalidDate"
        variant="no-border mt-1"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import CustomRadio from '@/components/common/CustomRadio';
import CustomDatePicker from '@/components/common/form/CustomDatePicker';
import { CustomDropDown, Error } from '@/components/common';
import {
  recurTypeEnum,
  recurRangeTypeEnum,
  recurMonthlyTypeEnum,
} from './utils/enums';
import { getRecurrence } from './utils/recurrence';

export default {
  name: 'RecurrenceDate',
  components: {
    CustomRadio,
    CustomDatePicker,
    CustomDropDown,
    Error,
  },
  props: {
    startDate: {
      type: Date,
      required: true,
    },
  },
  data: () => ({
    model: {
      recurrenceType: recurTypeEnum.DAILY,
      startDateValue: null,
      repeatEach: null,
      weekDays: [
        { name: 'Lunes', index: 0, value: null },
        { name: 'Martes', index: 1, value: null },
        { name: 'Miércoles', index: 2, value: null },
        { name: 'Jueves', index: 3, value: null },
        { name: 'Viernes', index: 4, value: null },
        { name: 'Sábado', index: 5, value: null },
      ],
      monthRecurrType: null,
      monthDay: null,
      monthPlace: null,
      monthPeriodType: null,
      repeatEachMonth: null,
      //range params
      rangeType: null,
      rangeFinalizeDate: null,
      rangeAfterOf: null,
    },
    ocurrences: [],
    validations: {
      invalidDate: null,
      invalidWeekDay: null,
    },
  }),
  computed: {
    recurType() {
      return recurTypeEnum;
    },
    recurRangeType() {
      return recurRangeTypeEnum;
    },
    recurMonthType() {
      return recurMonthlyTypeEnum;
    },
    recurrenceOptions() {
      return [
        { label: 'Diario', value: 1 },
        { label: 'Semanal', value: 2 },
        { label: 'Mensual', value: 3 },
      ];
    },
    rangeAfterOfOptions() {
      return [1, 2, 3, 4, 5, 6, 7];
    },
    daysOptions() {
      return [
        { name: 'Lunes', value: null },
        { name: 'Martes', value: null },
        { name: 'Miércoles', value: null },
        { name: 'Jueves', value: null },
        { name: 'Viernes', value: null },
        { name: 'Sábado', value: null },
      ];
    },
    weekOptions() {
      return [1, 2, 3, 4];
    },
    monthDaysOptions() {
      return Array.from(Array(31).keys()).map((x) => ({
        id: x + 1,
        name: x + 1,
      }));
    },
    monthsOptions() {
      return Array.from(Array(12).keys()).map((x) => ({
        id: x + 1,
        name: x + 1,
      }));
    },
    monthPlaceTypeOptions() {
      return [
        { id: 1, name: 'Primer(a)' },
        { id: 2, name: 'Segundo(a)' },
        { id: 3, name: 'Tercer(a)' },
        { id: 4, name: 'Cuarto(a)' },
        { id: 5, name: 'Último(a)' },
      ];
    },
    monthPeriodTypeOptions() {
      return [
        { id: 1, name: 'Día' },
        { id: 2, name: 'Semana' },
      ];
    },
    minStartDate() {
      return moment()
        .add('days', -1)
        .toDate();
    },
  },
  watch: {
    startDate: {
      handler() {
        if (this.startDate) {
          this.model = {
            ...this.model,
            startDateValue: this.startDate,
          };
          this.validateDate();
        }
      },
      immediate: true,
    },
    model: {
      handler() {
        this.validateDate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onChangeRangeRecurrType() {
      this.model = {
        ...this.model,
        rangeFinalizeDate: null,
        rangeAfterOf: null,
      };
      this.validations.invalidDate = null;
    },
    onChangeRecurrenceType() {
      this.model = {
        ...this.model,
        repeatEach: null,
        monthDay: null,
        monthRecurrType: null,
      };
    },
    onChangeMonthType() {
      this.model = {
        ...this.model,
        monthDay: null,
        repeatEach: null,
      };
    },
    getRepeatEachValue() {
      return parseInt(this.model.recurrenceType) === this.recurType.MONTHLY
        ? this.model.repeatEach?.id ?? 0
        : this.model.repeatEach ?? 0;
    },
    validateDate() {
      let isValid = true;

      //weekday validation
      if (this.model.recurrenceType == this.recurType.WEEKLY) {
        const hasSelect =
          this.model.weekDays.filter((x) => x.value === true).length == 0;
        if (hasSelect) {
          this.validations.invalidWeekDay =
            'Debe seleccionar al menos un día de la semana.';
          isValid = false;
        } else {
          this.validations.invalidWeekDay = null;
        }
      }

      if (this.model.startDateValue && this.model.rangeType) {
        //date validation
        if (this.model.rangeType == this.recurRangeType.DATE_FINALIZE) {
          if (this.model.startDateValue && this.model.rangeFinalizeDate) {
            if (
              new Date(this.model.startDateValue) >
              new Date(this.model.rangeFinalizeDate)
            ) {
              this.validations.invalidDate =
                'La fecha de finalización no puede ser inferior a la fecha de inicio.';
              isValid = false;
            } else {
              this.validations.invalidDate = null;
            }
          }
        }

        if (isValid) {
          this.ocurrences = getRecurrence(
            parseInt(this.model.recurrenceType), //recur type
            parseInt(this.model.rangeType), //recur range type
            new Date(this.model.startDateValue), //start date
            new Date(this.model.rangeFinalizeDate ?? new Date()), //end date
            parseInt(this.model.rangeAfterOf ?? 0), //count (for DATE_AFTER_OF)
            parseInt(this.getRepeatEachValue()), //repeat each (in week for WEEKLY and MONTHLY)
            this.model.weekDays.filter((x) => x.value).map((x) => x.index), //by week day (monday = 0, tuesday = 1, etc..., for WEEKLY)
            this.model.monthDay?.id //bymonthday (for MONTHLY)
          );
        } else {
          this.ocurrences = [];
        }
        this.$emit('input', {
          ocurrences: this.ocurrences,
          isValid: !this.validations.invalidDate,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.date-after {
  width: 70px !important;
}
.regular-size {
  width: 100px !important;
}
.large-size {
  width: 200px !important;
}
</style>
